export type FormatAction =
  | "bold"
  | "italic"
  | "underline"
  | "strike"
  | "code"
  | "codeBlock"
  | "bullet"
  | "number"
  | "quote"
  | "clear";

export type MentionTrigger = { trigger: "@" | "#"; query: string; length: number };
export type EmojiTrigger = { query: string; length: number };

export function mentionTriggerAt(text: string): MentionTrigger | null {
  const match = text.match(/(?:^|\s)([@#])([\w-]{0,48})$/);
  if (match?.[1] === "@" && ["channel", "here"].includes((match[2] ?? "").toLowerCase())) return null;
  return match ? { trigger: match[1] as "@" | "#", query: match[2] ?? "", length: (match[2]?.length ?? 0) + 1 } : null;
}

export function emojiTriggerAt(text: string): EmojiTrigger | null {
  const match = text.match(/(?:^|\s):([\w+-]{0,48})$/);
  return match ? { query: match[1] ?? "", length: (match[1]?.length ?? 0) + 1 } : null;
}
